import { render, staticRenderFns } from "./WhiteHolder.vue?vue&type=template&id=473f86ee&scoped=true&"
var script = {}
import style0 from "./WhiteHolder.vue?vue&type=style&index=0&id=473f86ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473f86ee",
  null
  
)

export default component.exports